// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"94f7609a","143":"02480d5b","189":"51d493cc","196":"05cb68c3","237":"034e8b46","299":"74b881a3","350":"5e2b6c7f","400":"ef953421","401":"9c88ff89","453":"f9d06b21","736":"0ac24cfb","840":"b184bb60","916":"c745e0cb"}[chunkId] + ".chunk.js";
};